import React from "react";
import { Line, defaults } from "react-chartjs-2";
import I18n from "../../../i18n/I18n";
import styles from "./DaySwitch.scss";

const DaySwitch = props => {
  const { getDataByDays, daysSelected } = props;
  return (
    <div className={styles.graphWrapper}>
      <div className={styles.graphTitleWrapper}>
        <div className={styles.daysSwitch}>
          {false && (
            <a className={`${styles.daybtn} ${styles.selected}`}>
              {I18n.getText("dashboard.all", {}, "All")}
            </a>
          )}
          <a
            className={`${styles.daybtn} ${
              daysSelected === 7 ? styles.selected : ""
            }`}
            onClick={() => getDataByDays(7)}
          >
            {I18n.getText("dashboard.week", {}, "1W")}
          </a>
          {false && (
            <a
              className={`${styles.daybtn} ${
                daysSelected === 14 ? styles.selected : ""
              }`}
            >
              {I18n.getText("dashboard.two-week", {}, "2W")}
            </a>
          )}
          <a
            className={`${styles.daybtn} ${
              daysSelected === 30 ? styles.selected : ""
            }`}
            onClick={() => getDataByDays(30)}
          >
            {I18n.getText("dashboard.one-month", {}, "1M")}
          </a>
          {false && (
            <a
              className={`${styles.daybtn} ${
                daysSelected === 90 ? styles.selected : ""
              }`}
            >
              {I18n.getText("dashboard.three-months", {}, "3M")}
            </a>
          )}
          <a
            className={`${styles.daybtn} ${
              daysSelected === 365 ? styles.selected : ""
            }`}
            onClick={() => getDataByDays(365)}
          >
            {I18n.getText("dashboard.year", {}, "1Y")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default DaySwitch;



// WEBPACK FOOTER //
// ./src/components/dashboard/daySwitch/DaySwitch.js